// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__TTDaN","contrainer":"styles_contrainer__dB3dA"};